import { MegaMenuNavigationItem } from '@layouts/MegaMenu/MegaMenu.types';
import React from 'react';
import { getPathLink } from './MobileNavigationList.utils';

interface MobileNavigationListProps {
  navigation?: MegaMenuNavigationItem[];
  contact: {
    Text: string;
    Href: string;
  };
}

export const MobileNavigationList = ({ navigation = [], contact }: MobileNavigationListProps) => {
  const pathLink = getPathLink();
  const hasNavigationList = navigation.length > 0;

  const addToMegaMenu = (index: string) => {
    window.localStorage.setItem('menuContainerLink', index);
    const el = document.getElementById(`mobile-mm-${index}-1-1`);
    if (el) {
      el.classList.remove('move-from-right');
      el.classList.remove('hidden');
      el.classList.add('move-from-left');
    }
  };

  const onNavItemClick = (nav: MegaMenuNavigationItem) => {
    if (nav.NoSubCategory) {
      window.localStorage.setItem('menuContainerLink', nav.ContainerLink);
      window.location.href = nav.UrlSegment;
    } else {
      addToMegaMenu(nav.ContainerLink);
    }
  };

  if (!hasNavigationList) return null;

  return (
    <>
      {navigation.map((nav, index) => (
        <li onClick={() => onNavItemClick(nav)} key={index} className='l-header-mobile-menu-item'>
          <span>{nav.Name}</span>
          {!nav.NoSubCategory && <i className='icon-angle-right' />}
        </li>
      ))}
      <li
        key={-1}
        onClick={() => {
          window.localStorage.setItem('menuContainerLink', '');
          window.location.href = pathLink + contact.Href;
        }}
        className='l-header-mobile-menu-item'
      >
        {contact.Text}
      </li>
    </>
  );
};
